module.exports = __webpack_public_path__ + "assets/2c9b790f5e5189cab7e853f16697ca05.wav";